// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"preview-module--wrapper--2byQm","preview":"preview-module--preview--9WFLe","close":"preview-module--close--3tHwq"};